import { campaignMetrics, ChartDataResponse, DimensionInfo, MetricInfo } from "@api/common";
import { AppState, currentReportCampaign, toPieData } from "@store";
import { FetchingState } from "rd-redux-http";
import * as React from "react";
import { connect } from "react-redux";
import { ChartWithTable } from "./ChartWithTable";
import { Pie } from "./PieChart";
import { filterDimensionsByData } from "./filterDimensionsByData";

interface DemographicGenderChartComponentProps {
    metrics: MetricInfo[];
    dimensions: DimensionInfo[];
    data: ChartDataResponse;
}

function DemographicGenderChartComponent({ metrics, dimensions, data }: DemographicGenderChartComponentProps) {
    return (
        <ChartWithTable title="Demographic" subtitle="Gender" data={data} metrics={metrics} dimensions={dimensions}>
            {metric => <Pie circleWidth={10} data={toPieData(data, metric, dimensions)} />}
        </ChartWithTable>
    );
}

export const DemographicGenderChart = connect(
    (appState: AppState): DemographicGenderChartComponentProps => {
        const campaign = currentReportCampaign(appState);
        const metrics = campaignMetrics(campaign ? campaign.unit : "CPM");

        const data = FetchingState.getDataOrDefault(appState.reports.chartData.genderData, {
            metrics: [],
            dimensions: []
        });

        const genders = FetchingState.getDataOrDefault(appState.mappings.gender, []);

        const colors = ["#258CA1", "#DB4A65", "#994F7E"];

        return {
            metrics,
            data,
            dimensions: filterDimensionsByData(
                genders.map<DimensionInfo>((item, index) => ({
                    dimension: item.type.toLowerCase(),
                    title: item.type,
                    color: colors[index]
                })),
                data
            )
        };
    }
)(DemographicGenderChartComponent);
